import React from 'react'

import { ColumnProps } from 'antd/lib/table'
import { FormikProps } from 'formik'

import { EmployeeReimbursementsDue } from 'core/application/adminDashboard/reimbursements/reimbursementsDue/getReimbursementsDue'

import { formatMoney } from 'common/moneyFormatter'

import { DropdownVisible, ReimbursementsDueToSubmit } from './index'
import SelectReimbursementDueAmountProps from './selectReimbursementDueAmount'

export const reimbursementsDueColumns = (
  formik: FormikProps<any>,
  translate: (key: string) => string,
  reimbursementsDueToSubmit: ReimbursementsDueToSubmit[],
  dropdownVisible: DropdownVisible[],
  setDropdownVisibility: (key: string, visible: boolean) => void,
  setReimbursementsDue: (key: string, amount: number) => void,
  hasESPR: boolean,
): ColumnProps<EmployeeReimbursementsDue>[] => {
  const taxColumns: ColumnProps<EmployeeReimbursementsDue>[] = hasESPR
    ? [
        {
          title: translate('admin-dashboard.reimbursements.reimbursements-due.taxed-label'),
          dataIndex: 'taxable',
          key: 'taxable',
          align: 'right',
          render: (item: number) => {
            return formatMoney(item)
          },
        },
        {
          title: translate('admin-dashboard.reimbursements.reimbursements-due.non-taxed-label'),
          dataIndex: 'nonTaxed',
          key: 'nonTaxed',
          align: 'right',
          render: (item: number, record: EmployeeReimbursementsDue) => {
            // Temporary commenting the display of asterisk due to customer support request
            // return `${formatMoney(item)}${record.hasTaxAdvantageAmount ? '*' : ''}`
            return formatMoney(item)
          },
        },
      ]
    : []

  const columns: ColumnProps<EmployeeReimbursementsDue>[] = [
    {
      title: translate('admin-dashboard.reimbursements.reimbursements-due.first-name-label'),
      dataIndex: 'firstName',
      key: 'firstName',
      align: 'left',
      className: 't-reimbursement-due-first-name',
    },
    {
      title: translate('admin-dashboard.reimbursements.reimbursements-due.last-name-label'),
      dataIndex: 'lastName',
      key: 'lastName',
      align: 'left',
      className: 't-reimbursement-due-last-name',
    },
    {
      title: translate('admin-dashboard.reimbursements.reimbursements-due.accrued-allowance-label'),
      dataIndex: 'accruedAllowance',
      key: 'accruedAllowance',
      align: 'right',
      render: (item: number) => {
        return formatMoney(item)
      },
      className: 't-reimbursement-due-accrued-allowance',
    },
    {
      title: translate('admin-dashboard.reimbursements.reimbursements-due.expenses-label'),
      dataIndex: 'totalExpenses',
      key: 'totalExpenses',
      align: 'right',
      render: (item: number) => {
        return formatMoney(item)
      },
      className: 't-reimbursement-due-total-expenses',
    },

    {
      title: translate('admin-dashboard.reimbursements.reimbursements-due.reimbursements-label'),
      dataIndex: 'reimbursements',
      key: 'reimbursements',
      align: 'right',
      render: (item: number) => {
        return formatMoney(item)
      },
      className: 't-reimbursement-due-total-reimbursements',
    },
    ...taxColumns,
    {
      title: translate('admin-dashboard.reimbursements.reimbursements-due.reimbursements-due-label'),
      dataIndex: 'reimbursementsDue',
      key: 'reimbursementsDue',
      align: 'right',
      width: '200px',
      render: (reimbursementDue: number, record: EmployeeReimbursementsDue) => {
        return (
          <SelectReimbursementDueAmountProps
            item={reimbursementDue}
            record={record}
            formik={formik}
            translate={translate}
            reimbursementsDueToSubmit={reimbursementsDueToSubmit}
            dropdownVisible={dropdownVisible}
            setDropdownVisibility={setDropdownVisibility}
            setReimbursementsDue={setReimbursementsDue}
          />
        )
      },
      className: 't-reimbursement-due-total-reimbursements-due',
    },
  ]

  return columns
}
